import React from 'react';
import { string } from 'prop-types';
import { FlexContainer } from '../../layouts/Wrapper/Base.components';
import Icon from '../Icon';
import Text from '../Text';
import { MobileWrapper } from '../MobileWrapper';

const MobilePageTitle = ({ icon, text }) => (
    <MobileWrapper>
        <FlexContainer pT={18} pX={23} align='center'>
            <Icon name={icon} size={13} right={5} color='#1EA02E' /><Text text={text} color='#1EA02E' size={16} />
        </FlexContainer>
    </MobileWrapper>
);

MobilePageTitle.propTypes = {
    icon: string,
    text: string
};

MobilePageTitle.defaultProps = {
    icon: 'layers',
    text: 'Título'
};

export default MobilePageTitle;
